import {
  defaultSystemCodeAddress,
  defaultSystemCodeArea,
  exists,
  SystemCodeAddress,
  SystemCodeAddressFromJSON,
  SystemCodeArea,
  SystemCodeAreaFromJSON
} from '@/api'

export interface UserAddress {
  addressCode: SystemCodeAddress
  zipCode: string
  areaCode: SystemCodeArea
  address: string
}

export function UserAddressFromJSON(json: any): UserAddress {
  return {
    addressCode: exists(json, 'address_code')
      ? SystemCodeAddressFromJSON(json.address_code)
      : defaultSystemCodeAddress(),
    zipCode: exists(json, 'zip_code') ? json.zip_code : '',
    areaCode: exists(json, 'area_code')
      ? SystemCodeAreaFromJSON(json.area_code)
      : defaultSystemCodeArea(),
    address: exists(json, 'address') ? json.address : ''
  }
}

export function UserAddressToJSON(value: UserAddress): any {
  return {
    address_code: value.addressCode.code,
    zip_code: value.zipCode,
    area_code: value.areaCode.code,
    address: value.address
  }
}

export const defaultUserAddress = (): UserAddress => ({
  addressCode: defaultSystemCodeAddress(),
  zipCode: '',
  areaCode: defaultSystemCodeArea(),
  address: ''
})
